module.exports = __webpack_public_path__ + "static/yoga-meditation-37d55c72b21fa5a1bc0fd33e282a5df4.jpg";